import { MAP_BRIDGES, NATIVE, WORLD_PX } from './archipelago.js';
import type { Point } from './types.js';

/** Полоса моста в пикселях мира (≈3.6 клетки: настил 1.4 + полоса проходимости в сетке) — для выпрямления пути по оси. */
export const BRIDGE_DECK_WIDTH = 145;
export const BRIDGE_RIVER_HALF_LENGTH = 40;
export interface WorldBridge {
  id: string;
  kind: 'sea' | 'river';
  from: Point;
  to: Point;
}

/** Оси настилов в нативных координатах карты (клетки v8, концы — на суше). Малые мосты через реки — клетки CROSSING. */
export const WORLD_BRIDGES: readonly WorldBridge[] = MAP_BRIDGES.map(
  (b, i): WorldBridge => ({
    id: `sea-${i}`,
    kind: 'sea',
    from: { x: b[0]!, y: b[1]! },
    to: { x: b[2]!, y: b[3]! },
  }),
);

export interface TileBridge extends WorldBridge {
  halfWidth: number;
}
/** Индексы клеток: renderer добавляет 0.5 к позиции армии. */
export function tileBridges(size: number): TileBridge[] {
  const scale = size / NATIVE.width;
  return WORLD_BRIDGES.map((b) => ({
    ...b,
    from: { x: b.from.x * scale - 0.5, y: b.from.y * scale - 0.5 },
    to: { x: b.to.x * scale - 0.5, y: b.to.y * scale - 0.5 },
    halfWidth: (BRIDGE_DECK_WIDTH * size) / WORLD_PX.width / 2,
  }));
}

export function projectOnBridge(point: Point, bridge: WorldBridge): Point & { fraction: number } {
  const dx = bridge.to.x - bridge.from.x,
    dy = bridge.to.y - bridge.from.y;
  const fraction = Math.max(
    0,
    Math.min(1, ((point.x - bridge.from.x) * dx + (point.y - bridge.from.y) * dy) / (dx * dx + dy * dy)),
  );
  return { x: bridge.from.x + fraction * dx, y: bridge.from.y + fraction * dy, fraction };
}
